import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export default function Terms() {
  return (
    <div className="container-fluid profileBox dashboardprofile">
      <Row>
        <Col lg={12}>
          <h1>Terms & Condition</h1>
        </Col>
      </Row>
    </div>
  );
}
